import React from "react";

export default function NoTopicMessage({ message }) {
    return (
        <div className="no-data">
            <p className="no-data__message">{message}</p>
        </div>
    );
}
